import createReducer from '@sift/resift/createReducer';
import { WidgetType, Widget } from 'pages/Homepage/typings';

export interface State {
  widgetTypes: Array<WidgetType> | null;
  widgets: Array<Widget> | null;
}

// ------------------------------------
// Constants
// ------------------------------------
export const SET_WIDGET_TYPES = 'SET_WIDGET_TYPES';
export const SET_WIDGETS = 'SET_WIDGETS';

// ------------------------------------
// Actions
// ------------------------------------
export const setWidgetTypes = (widgetTypes: Array<WidgetType>) => {
  return {
    type: SET_WIDGET_TYPES,
    identifier: 'homepage-widgets',
    payload: {
      widgetTypes,
    },
  };
};

export const setWidgets = (widgets: Array<Widget>) => {
  return {
    type: SET_WIDGETS,
    identifier: 'homepage-widgets',
    payload: {
      widgets,
    },
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SET_WIDGET_TYPES]: (state: State, action: any) => {
    return {
      ...state,
      widgetTypes: action.payload.widgetTypes,
    };
  },
  [SET_WIDGETS]: (state: State, action: any) => {
    return {
      ...state,
      widgets: action.payload.widgets,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState: State = {
  widgetTypes: null,
  widgets: null,
};

export default createReducer(initialState, ACTION_HANDLERS);
